// Generate user data from email
export const generateUserDataFromEmail = (email) => {
  const emailPrefix = email.split('@')[0];
  const domain = email.split('@')[1];
  
  // generate username from email
  const username = emailPrefix.toLowerCase().replace(/[^a-z0-9]/g, '');
  
  // split email prefix into name parts
  const nameParts = emailPrefix.split(/[._-]/);
  const firstName = nameParts[0] ? nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1).toLowerCase() : 'User';
  const lastName = nameParts[1] ? nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1).toLowerCase() : 'User';
  
  // generate random password
  const password = Math.random().toString(36).slice(-12) + Math.random().toString(36).toUpperCase().slice(-4) + '1!';
  
  // derive country from domain (best effort)
  let country = 'US';
  let timezone = 'America/New_York';
  
  if (domain.includes('ukr.net') || domain.includes('gmail.com') && email.includes('ua')) {
    country = 'UA';
    timezone = 'Europe/Kiev';
  } else if (domain.includes('gmail.com')) {
    country = 'US';
    timezone = 'America/New_York';
  } else if (domain.includes('yahoo.com')) {
    country = 'US';
    timezone = 'America/Los_Angeles';
  } else if (domain.includes('outlook.com') || domain.includes('hotmail.com')) {
    country = 'US';
    timezone = 'America/Chicago';
  }
  
  // get browser language
  const language = navigator.language || 'en-US';
  
  // displayName
  const displayName = `${firstName} ${lastName}`;
  
  // avatar URL
  const avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=random&size=200`;
  
  // bio
  const bio = `Hello! I am ${firstName}, a Tripsha user.`;
  
  // website
  const website = `https://${domain}`;
  
  // socialLinks
  const socialLinks = {
    facebook: '',
    twitter: '',
    instagram: '',
    linkedin: ''
  };
  
  // preferences
  const preferences = {
    emailNotifications: true,
    pushNotifications: true,
    newsletter: false
  };
  
  // phone (placeholder)
  const phone = '+1-555-0000';
  
  return {
    username,
    firstName,
    lastName,
    password,
    country,
    timezone,
    language,
    displayName,
    avatar,
    bio,
    website,
    socialLinks,
    preferences,
    phone
  };
}; 